var navigation = {
    selectors: {
        dropdown: '.navigation__secondary__item--parent',
        mobile: '.menu-item-has-children > a, .newsletter__title',
    },
    init: function () {
        var self = this;

        $(self.selectors.dropdown).on('click', function (e) {
            var $this = $(this);
            $this.toggleClass('opened');
        });

        $(document.body).on('click', function (e) {
            if (!$(e.target).closest(self.selector).length) {
                $(self.selector).removeClass('opened');
            }
        });

        self.mobile();
    },
    mobile: function () {
        var self = this,
            $mobileTriggers = $(self.selectors.mobile);

        $mobileTriggers.on('click', function (e) {
            var $this = $(this);

            if (
                $this.is('a') === false ||
                $this.attr('href') === '#' ||
                $this.hasClass('opened') === false
            ) {
                e.preventDefault();
                $mobileTriggers.removeClass('opened');
                $this.toggleClass('opened');
            }
        });
    },
};

export { navigation };
